module.exports = __webpack_public_path__ + "img/076.fc8e0c53.png";